import { render, staticRenderFns } from "./ruleSetting.vue?vue&type=template&id=f7e90bca&scoped=true"
import script from "./ruleSetting.vue?vue&type=script&lang=js"
export * from "./ruleSetting.vue?vue&type=script&lang=js"
import style0 from "./ruleSetting.vue?vue&type=style&index=0&id=f7e90bca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7e90bca",
  null
  
)

export default component.exports